import { render, staticRenderFns } from "./TextEditorField.vue?vue&type=template&id=16f48224"
import script from "./TextEditorField.vue?vue&type=script&lang=js"
export * from "./TextEditorField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports